<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: '応募者メッセージテンプレート一覧', pathName: 'settingMessageTemplates' }]"
        :title="'応募者メッセージテンプレート'+formTypeLabel"
        data-test="title"
      />
      <div>
        <div class="boss-scout-send-container">
          <form-item
            v-model="name"
          >
            <template #label>
              <span>テンプレート名<br>
                <small>（50文字以内）</small>
              </span>
            </template>
          </form-item>
          <form-item
            v-model="subject"
          >
            <template #label>
              <span>件名<br>
                <small>（200文字以内）</small>
              </span>
            </template>
          </form-item>
          <form-item-text-area
            ref="message"
            v-model="body"
            :class-name="'boss-send-textarea'"
            rows
            cols
            data-test="message-body"
          >
            <template #label>
              <span>本文<br>
                <small>（10000文字以内）</small>
              </span>
            </template>
            <template #header>
              <div class="padding-bottom-1">
                <button
                  class="boss-button"
                  data-test="user-name"
                  @click="insertionValue('■USER_NAME■ 様')"
                >
                  応募者名を挿入
                </button>
                <button
                  class="boss-button"
                  data-test="job-name"
                  @click="insertionValue('■JOB_NAME■')"
                >
                  求人名を挿入
                </button>
                <button
                  class="boss-button"
                  data-test="company-name"
                  @click="insertionValue(currentUser.companyUserDisplayName)"
                >
                  社名を挿入
                </button>
              </div>
            </template>
          </form-item-text-area>
        </div>
      </div>
      <form-button-area>
        <form-confirm-button
          :is-disabled="isConfirmButtonDisabled"
          :submit-label="`この内容でテンプレートを${formTypeLabel}する`"
          data-test="confirm-button"
          @submit-event="submit"
        />
      </form-button-area>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import FormItem from '@/components/atoms/FormItem'
import FormItemTextArea from '@/components/atoms/FormItemTextArea'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    SettingHeader,
    FormItem,
    FormItemTextArea,
    FormButtonArea,
    FormConfirmButton
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      name: '',
      subject: '',
      body: ''
    }
  },
  computed: {
    isEmptySubject () {
      return this.subject.trim().length === 0
    },
    isEmptyBody () {
      return this.body.trim().length === 0
    },
    isEmptyName () {
      return this.name.trim().length === 0
    },
    isConfirmButtonDisabled () {
      return this.isEmptySubject ||
        this.isEmptyBody ||
        this.isEmptyName
    },
    ...mapGetters({
      currentUser: 'currentUser'
    }),
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    }
  },
  created () {
    if (this.id) {
      this.$http.secured.get(`company/entry/message/templates/${this.id}`)
        .then(response => {
          this.name = response.data.name
          this.subject = response.data.subject
          this.body = response.data.body
        })
    } else {
      this.name = '新規テンプレート'
    }
  },
  methods: {
    insertionValue (value) {
      const cursorPosition = this.$refs.message.$refs.component.selectionStart
      this.body = this.body.substr(0, cursorPosition) + value + this.body.substr(cursorPosition, this.body.length)
    },
    submit () {
      this.$emit('submit', this.name, this.subject, this.body)
    }
  }
}
</script>
